// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";

const openBackOrdersUrl = "/api/str/openbackorderbyproducts";

export interface OpenBackOrdersApiParameter extends ApiParameter {
    shipToAddress?: string;
    orderNumber?: string;
    releaseNumber?: string;
    page?: number;
    pageSize?: number;
    orderedBy?: string;
    partNumber?: string;
    description?: string;
}

export interface OpenBackOrderModel {
    orderId: string;
    qty: number;
    partNumber: string;
    productUri: string;
    description: string;
    orderDate: string;
    customerPo?: string;
    shipDate?: string;
    orderedBy?: string;
    requiredDate?: string;
    customerPartNumber?: string;
    orderStatus?: string;
    shipVia?: string;
    releaseNumber?: string;
}

export interface OpenBackOrdersResultModel {
    defaultPageSize: number;
    openBackOrderList: OpenBackOrderModel[];
    pageNumber: number;
    pageSize: number;
    totalItemCount: number;
    pagination?: PaginationModel;
    isSubscribedToOpenBackOrderEmail?: boolean;
}

export interface SendOpenBackOrdersEmailApiParameter extends ApiParameter {
    email?: string;
}

export interface OpenBackOrderEmailProductModel {
    description?: string;
    price?: string;
    productNumber?: string;
    urlSegment?: string;
}

export async function getOpenBackOrders(data: OpenBackOrdersApiParameter): Promise<OpenBackOrdersResultModel> {
    const openBackOrders = await get<OpenBackOrdersResultModel>(`${openBackOrdersUrl}/getopenbackorder`, data);
    return openBackOrders;
}

export async function subscribe(): Promise<ServiceResult<void>> {
    const result = await post<ServiceResult<void>>(`${openBackOrdersUrl}/subscribe`);
    return result;
}

export async function unsubscribe(): Promise<ServiceResult<void>> {
    const result = await post<ServiceResult<void>>(`${openBackOrdersUrl}/unSubscribe`);
    return result;
}

export async function sendEmail(parameter: SendOpenBackOrdersEmailApiParameter) {
    const result = await post<SendOpenBackOrdersEmailApiParameter, ServiceResult<void>>(`${openBackOrdersUrl}/sendemail?email=${parameter.email}`);
    return result;
}